import http from "./httpService";
import config from "./config.json";

// Get Full Page Text
export const getHome = () => {
    return http.get(`${config.localApi}/api/page/home`);
};

export const getAbout = () => {
    return http.get(`${config.localApi}/api/page/about`);
};
export const getService = () => {
    return http.get(`${config.localApi}/api/page/service`);
};

export const getContact = () => {
    return http.get(`${config.localApi}/api/page/contact`);
};

// Get Admin Box Text
export const getAdminBoxTxt = (dataId) => {
    return http.get(`${config.localApi}/api/Admin/${dataId}`);
};

// Post Email
export const postEmail = (Form) => {
    return http.post(`${config.localApi}/api/page/send-mail`, JSON.stringify(Form));
};
